import React, { useState, useRef, useEffect } from "react";
import { FiFilter } from "react-icons/fi";

const Filter = ({ CF_Filters, CF_FilterObj, setCF_FilterObj }) => {
  const [showFilterBubble, setShowFilterBubble] = useState(false);
  const [searchReferrer, setSearchReferrer] = useState("");
  const [utmKey, setUtmKey] = useState("");
  const [utmValue, setUtmValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  // Initialize filters with proper default values
  const [filters, setFilters] = useState({
    ...CF_FilterObj,
    referrers: CF_FilterObj.referrers || [],
    utmParams: CF_FilterObj.utmParams || [],
    // deviceType: CF_FilterObj.deviceType || "all",
    userType: CF_FilterObj.userType || "all",
    userSource: CF_FilterObj.userSource || "all",
  });

  console.log("CF_Filters", CF_Filters)
  console.log("filters", filters)
  const filterRef = useRef();


  const handleAppyFilter = () => {
    setCF_FilterObj((prev) => {
      return {
        ...prev,  // Keep all previous properties
        ...filters, // Only update the changed filters
      };
    });
  }

  // Handle outside click for filter bubble
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setShowFilterBubble(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  // Update filters
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value === "all" ? "" : value,
      referrers: prev.referrers || [],
      utmParams: prev.utmParams || [],
    }));
  };

  // Add a referrer
  const handleAddReferrer = (e) => {
    if (e.key === "Enter") {
      const trimmedReferrer = searchReferrer.trim();
      if (!trimmedReferrer) {
        setErrorMessage("Referrer cannot be empty.");
        return;
      }
      if (filters.referrers.includes(trimmedReferrer)) {
        setErrorMessage("Referrer already exists.");
        return;
      }
      setFilters((prev) => ({
        ...prev,
        referrers: [...prev.referrers, trimmedReferrer],
      }));
      setSearchReferrer("");
      setErrorMessage("");
    }
  };

  // Remove a referrer
  const handleRemoveReferrer = (referrer) => {
    setFilters((prev) => ({
      ...prev,
      referrers: prev.referrers.filter((item) => item !== referrer),
    }));
  };

  // Add a UTM parameter
  const handleAddUtmParam = () => {
    const trimmedKey = utmKey.trim();
    const trimmedValue = utmValue.trim();
    if (!trimmedKey || !trimmedValue) {
      setErrorMessage("UTM key and value cannot be empty.");
      return;
    }
    if (
      filters.utmParams.some(
        (param) => param.key === trimmedKey && param.value === trimmedValue
      )
    ) {
      setErrorMessage("UTM parameter already exists.");
      return;
    }
    setFilters((prev) => ({
      ...prev,
      utmParams: [...prev.utmParams, { key: trimmedKey, value: trimmedValue }],
    }));
    setUtmKey("");
    setUtmValue("");
    setErrorMessage("");
  };

  // Remove a UTM parameter
  const handleRemoveUtmParam = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      utmParams: prev.utmParams.filter(
        (param) => param.key !== key || param.value !== value
      ),
    }));
  };

  return (
    <div className=" inline-block rounded-lg p-3">
    <button
    onClick={() => setShowFilterBubble((prev) => !prev)}
    className="p-2 rounded-md border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white transition"
    >
        <FiFilter className="w-6 h-6" />
    </button>



      {/* Filter Bubble */}
      {showFilterBubble && (
        <div
          className="absolute flex flex-col space-y-4 w-2/3 bg-white border border-gray-300 rounded shadow-lg p-4 z-10"
          ref={filterRef}
        >
          <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-gray-300"></span>

          {/* Dropdown Filters */}
          <div className="flex space-x-4">
            {[
              // { value: "deviceType", options: CF_Filters.deviceType.options },
              { value: "userType", options: CF_Filters.userType.options },
              { value: "userSource", options: CF_Filters.userSource.options },
            ].map(({ value, options }) => (
              <div key={value} className="w-44 flex-1">
                <label className="block mb-1 text-sm text-gray-600">
                  {CF_Filters[value]?.title}
                </label>
                <select
                  onChange={(e) => handleFilterChange(value, e.target.value)}
                  value={filters[value]}
                  className="border px-2 py-1 w-full"
                >
                  {options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.title === "all" ? `All ${CF_Filters[value]?.title}` : option.title}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>

          {/* Referrer Filter */}
          <div>
            <label className="block mb-1 text-sm text-gray-600">Referrer</label>
            <input
              type="text"
              value={searchReferrer}
              onChange={(e) => setSearchReferrer(e.target.value)}
              onKeyDown={handleAddReferrer}
              className="border px-2 py-1 w-full"
              placeholder="Add referrer and press Enter"
            />
            <TagList items={filters.referrers || []} onRemove={handleRemoveReferrer} />
          </div>

          {/* UTM Parameters */}
          <div>
            <label className="block mb-1 text-sm text-gray-600">UTM Parameters</label>
            <div className="flex gap-2 items-center">
            <div className="flex flex-1 space-x-2">
              <input
                type="text"
                value={utmKey}
                onChange={(e) => setUtmKey(e.target.value)}
                className="border px-2 py-1 w-1/2"
                placeholder="UTM Key"
              />
              <input
                type="text"
                value={utmValue}
                onChange={(e) => setUtmValue(e.target.value)}
                className="border px-2 py-1 w-1/2"
                placeholder="UTM Value"
              />
            </div>
            <button
              onClick={handleAddUtmParam}
              className="basis-[132px] text-blue-500 p-1 px-4 rounded-md hover:border-[1.25px] hover:bg-blue-500 hover:text-white hover:border-blue-500 transition"
            >
              Add UTM
            </button>
            </div>

            <TagList
              items={filters?.utmParams?.map((param) => `${param.key}: ${param.value}`) || []}
              onRemove={(item) => {
                const [key, value] = item.split(": ");
                handleRemoveUtmParam(key, value);
              }}
            />
          </div>
          

          <button
              onClick={handleAppyFilter}
              className="border-[1.35px] bg-blue-500 border-blue-500 text-white py-1 px-4 mt-2 rounded-md hover:border-[1.25px] hover:bg-blue-600 hover:text-white  transition"
            >
              Apply Filter
            </button>
          {/* Error Message */}
          {errorMessage && (
            <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
          )}
        </div>
      )}
    </div>
  );
};

// Reusable TagList Component
const TagList = ({ items = [], onRemove }) => (
  <div className="mt-2 flex flex-wrap gap-2">
    {items.map((item, index) => (
      <span
        key={index}
        className="inline-flex items-center bg-cyan-50 text-sm px-2 py-1 rounded"
      >
        {item}
        <button
          onClick={() => onRemove(item)}
          className="ml-2 text-red-500 hover:text-red-700"
        >
          x
        </button>
      </span>
    ))}
  </div>
);

export default Filter;
